'use client';

import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled, { css } from 'styled-components';
import { pickBorderColor, pickBorderWidth, validBorderWidthValues } from '@nib/layout';
// eslint-disable-next-line  @typescript-eslint/no-unused-vars
const Divider = styled(_ref => {
  let {
    color,
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsx("hr", {
    "data-mesh-component": "DIVIDER",
    ...props
  });
})`
  margin: 0;
  border: none;
  ${props => props.size && props.color && css`
      border-top: ${validBorderWidthValues.includes(props.size) ? pickBorderWidth(props.size) : props.size} solid ${pickBorderColor(props.color)};
    `}
`;
Divider.displayName = 'Divider';
Divider.defaultProps = {
  color: 'default',
  size: 'fine'
};
export default Divider;